import React from 'react';
import { BettingStatus } from '@playball/common/dto/Betting';

interface BettingStatusBadgeProps {
    status: BettingStatus;
    className?: string;
}

const statusMap: Record<BettingStatus, { text: string; className: string }> = {
    scheduled: { text: '예정', className: 'bg-info' },
    inprogress: { text: '진행 중', className: 'bg-warning' },
    closed: { text: '마감', className: 'bg-secondary' },
    finished: { text: '종료', className: 'bg-success' },
};

const BettingStatusBadge: React.FC<BettingStatusBadgeProps> = ({ status, className }) => {
    const baseClasses = "badge rounded-pill";
    const combinedClassName = className ? `${baseClasses} ${className}` : baseClasses;

    const statusInfo = statusMap[status] || { text: '알 수 없음', className: 'bg-light text-dark' };

    return <span className={`${combinedClassName} ${statusInfo.className}`}>{statusInfo.text}</span>;
};

export default BettingStatusBadge;
